import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import SemanticUIMenu from 'semantic-ui-react/dist/commonjs/collections/Menu';
import Button from 'semantic-ui-react/dist/commonjs/elements/Button';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';
import { LinksDisplayName, LogoDisplayName, MenuDisplayName, ItemDisplayName } from './SiteNavigation.constants';
import { mergeLinks } from './SiteNavigation.utils';
import Links from './components/Links';
import Logo from './components/Logo';
import Menu from './components/Menu';
import Toggleable from '../../../darkmatter/Toggleable';
import useScroll from '../../../modules/foundation/hooks/use-scroll';
import { findComponentsByType } from '../../../services/components';
import { ChildrenPropType } from '../../../services/proptypes';
import { classNames } from '../../../utils/classname';
import './SiteNavigation.css';
var defaultProps = {
  fixed: false,
  bordered: false,
  children: null,
  widths: null,
  hamburgerButtonPosition: 'left',
  fullScreen: false
};

// @deprecated: prefer using Navigation component of the navigation module
function SiteNavigation(_ref) {
  var fixed = _ref.fixed,
    bordered = _ref.bordered,
    children = _ref.children,
    widths = _ref.widths,
    hamburgerButtonPosition = _ref.hamburgerButtonPosition,
    fullScreen = _ref.fullScreen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    setToggled = _useState2[1];
  var _useScroll = useScroll(),
    enableBodyScroll = _useScroll.enableBodyScroll,
    disableBodyScroll = _useScroll.disableBodyScroll;
  var desktopNavigation = /*#__PURE__*/React.createElement(SemanticUIMenu, {
    secondary: true,
    stackable: true,
    borderless: !bordered,
    size: "large",
    fixed: fixed ? 'top' : null,
    widths: widths,
    className: "site-navigation navigation-container desktop"
  }, children);
  var childrenArray = React.Children.toArray(children);
  var logoChildren = findComponentsByType(childrenArray, 'Logo');
  var mobileLogoChild = logoChildren.length > 0 ? logoChildren[0] : null;
  var mobileMenuItems = mergeLinks(findComponentsByType(childrenArray, 'Links'));
  function handleMobileToggle(toggle, onToggle) {
    if (fullScreen) {
      if (toggle) {
        enableBodyScroll();
      } else {
        disableBodyScroll();
      }
    }
    setToggled(!toggle);
    onToggle();
  }
  var mobileNavigation = /*#__PURE__*/React.createElement(Segment, {
    className: "site-navigation navigation-container mobile ".concat(classNames({
      fullScreen: fullScreen,
      toggled: toggled
    }))
  }, /*#__PURE__*/React.createElement(Toggleable, null, function (toggle, onToggle) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "mobile-nav-header"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        handleMobileToggle(toggle, onToggle);
      },
      style: {
        "float": hamburgerButtonPosition
      },
      "aria-label": "Open navigation bar"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "bars",
      size: "large",
      style: {
        margin: '0 auto',
        height: 'unset'
      }
    })), mobileLogoChild), toggle && /*#__PURE__*/React.createElement(SemanticUIMenu, {
      secondary: true,
      stackable: true,
      vertical: true,
      fluid: true,
      borderless: !bordered,
      size: "large",
      fixed: fixed ? 'top' : null,
      className: "mobile-nav-menu"
    }, mobileMenuItems));
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, desktopNavigation, mobileNavigation);
}
SiteNavigation.defaultProps = defaultProps;
export default SiteNavigation;
SiteNavigation.Links = Links;
SiteNavigation.Links.displayName = LinksDisplayName;
SiteNavigation.Logo = Logo;
SiteNavigation.Logo.displayName = LogoDisplayName;
SiteNavigation.Menu = Menu;
SiteNavigation.Menu.displayName = MenuDisplayName;
SiteNavigation.Item = SemanticUIMenu.Item;
SiteNavigation.Item.displayName = ItemDisplayName;